(function () {
  var attribution = getAttribution();

  if (!attribution) return;

  preserveAttributionLinks(attribution);
  applyAttributionToForms(attribution);
  updateCartAttributes(attribution);

  document.addEventListener(
    'submit',
    function (event) {
      if (!(event.target instanceof HTMLFormElement)) return;

      var currentAttribution = getAttribution() || attribution;

      if (!currentAttribution) return;

      if (isCartAddForm(event.target)) {
        applyAttributionToForm(event.target, currentAttribution);
      }

      if (isCartOrCheckoutForm(event.target)) {
        updateCartAttributes(currentAttribution);
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      if (!(event.target instanceof Element)) return;

      var currentAttribution = getAttribution() || attribution;
      if (!currentAttribution) return;

      var checkoutTrigger = event.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
      if (checkoutTrigger) {
        updateCartAttributes(currentAttribution);
      }
    },
    true
  );

  if ('MutationObserver' in window) {
    new MutationObserver(function () {
      var currentAttribution = getAttribution() || attribution;
      if (!currentAttribution) return;

      applyAttributionToForms(currentAttribution);
      preserveAttributionLinks(currentAttribution);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function getAttribution() {
    var params = new URLSearchParams(window.location.search);
    var bellsCrossingParticipant = getBellsCrossingParticipant(params);
    var hasBellsContextParams = hasBellsCrossingParams(params);

    if (params.has('campaign')) {
      var suppliedCampaign = sanitizeCampaign(params.get('campaign'));
      writeSession('campaign', suppliedCampaign);

      if (suppliedCampaign === 'bells-crossing') {
        if (bellsCrossingParticipant) {
          writeSession('participant', bellsCrossingParticipant);
          writeSession('student_identifier', bellsCrossingParticipant);
          clearSession('influencer_ref');
        } else if (hasBellsContextParams) {
          clearSession('participant');
          clearSession('student_identifier');
        }
      } else {
        clearSession('participant');
        clearSession('student_identifier');
      }

      if (suppliedCampaign !== 'ghs' || !params.has('ref')) {
        clearSession('influencer_ref');
      }
    } else if (isBellsCrossingContext() && hasBellsContextParams) {
      writeSession('campaign', 'bells-crossing');

      if (bellsCrossingParticipant) {
        writeSession('participant', bellsCrossingParticipant);
        writeSession('student_identifier', bellsCrossingParticipant);
        clearSession('influencer_ref');
      } else {
        clearSession('participant');
        clearSession('student_identifier');
      }
    }

    if (params.has('student')) {
      writeSession('student_name', titleFromSlug(params.get('student')));
    }

    if (params.has('student_name')) {
      writeSession('student_name', titleFromSlug(params.get('student_name')));
    }

    if (params.has('student_identifier')) {
      writeSession('student_identifier', sanitizeToken(params.get('student_identifier')));
    }

    if (params.has('teacher_first')) {
      writeSession('teacher_first_name', titleFromSlug(params.get('teacher_first')));
    }

    if (params.has('teacher_last')) {
      writeSession('teacher_last_name', titleFromSlug(params.get('teacher_last')));
    }

    if (params.has('teacher')) {
      writeSession('teacher_name', titleFromSlug(params.get('teacher')));
    }

    if (params.has('teacher_name')) {
      writeSession('teacher_name', titleFromSlug(params.get('teacher_name')));
    }

    if (params.has('ref')) {
      writeSession('influencer_ref', sanitizeToken(params.get('ref')));
      clearSession('participant');
    }

    var campaign = readSession('campaign');
    var participant = readSession('participant');
    var influencerRef = readSession('influencer_ref');
    var studentName = readSession('student_name');
    var studentIdentifier = readSession('student_identifier') || participant;
    var teacherFirstName = readSession('teacher_first_name');
    var teacherLastName = readSession('teacher_last_name');
    var teacherName = readSession('teacher_name') || [teacherFirstName, teacherLastName].filter(Boolean).join(' ');

    if (campaign === 'bells-crossing' && participant) {
      return {
        campaign: campaign,
        params: {
          campaign: campaign,
          participant: participant
        },
        lineItemProperties: {
          _common_bearing_campaign: campaign,
          _common_bearing_participant: participant,
          _campaign_name: 'Bells Crossing',
          _student_name: studentName,
          _student_identifier: studentIdentifier,
          _teacher_first_name: teacherFirstName,
          _teacher_last_name: teacherLastName,
          _teacher_name: teacherName
        },
        cartAttributes: {
          __common_bearing_campaign: campaign,
          __common_bearing_participant: participant,
          campaign_name: 'Bells Crossing',
          student_name: studentName,
          student_identifier: studentIdentifier,
          teacher_first_name: teacherFirstName,
          teacher_last_name: teacherLastName,
          teacher_name: teacherName
        }
      };
    }

    if (campaign === 'ghs' && influencerRef) {
      return {
        campaign: campaign,
        params: {
          campaign: campaign,
          ref: influencerRef
        },
        lineItemProperties: {
          _common_bearing_campaign: campaign,
          _common_bearing_influencer_ref: influencerRef,
          _common_bearing_attribution_type: 'influencer'
        },
        cartAttributes: {
          __common_bearing_campaign: campaign,
          __common_bearing_influencer_ref: influencerRef,
          __common_bearing_attribution_type: 'influencer'
        }
      };
    }

    return null;
  }

  function applyAttributionToForms(data) {
    document.querySelectorAll('form').forEach(function (form) {
      if (isCartAddForm(form)) {
        applyAttributionToForm(form, data);
      }
    });
  }

  function applyAttributionToForm(form, data) {
    Object.keys(data.lineItemProperties).forEach(function (key) {
      var name = 'properties[' + key + ']';
      var input = form.querySelector('input[name="' + name + '"]');

      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        form.appendChild(input);
      }

      input.value = data.lineItemProperties[key];
    });
  }

  function hasBellsCrossingParams(params) {
    return (
      getBellsCrossingParticipant(params) ||
      params.has('student') ||
      params.has('student_name') ||
      params.has('teacher_first') ||
      params.has('teacher_last') ||
      params.has('teacher') ||
      params.has('teacher_name')
    );
  }

  function getBellsCrossingParticipant(params) {
    return getFirstParam(params, ['participant', 'student_identifier', 'student_id', 'participant_id', 'student_code']);
  }

  function getFirstParam(params, names) {
    for (var index = 0; index < names.length; index += 1) {
      if (params.has(names[index])) {
        var value = sanitizeToken(params.get(names[index]));
        if (value) return value;
      }
    }

    return '';
  }

  function isBellsCrossingContext() {
    return document.querySelector('.bells-crossing') || /\/pages\/bells-crossing/.test(window.location.pathname);
  }

  function preserveAttributionLinks(data) {
    var selectors = [
      '.bells-crossing [data-preserve-attribution-link]',
      '.common-bearing-page [data-preserve-referral-link]',
      '.greenville-humane [data-preserve-referral-link]'
    ];

    document.querySelectorAll(selectors.join(',')).forEach(function (link) {
      try {
        var url = new URL(link.getAttribute('href'), window.location.origin);
        Object.keys(data.params).forEach(function (key) {
          url.searchParams.set(key, data.params[key]);
        });
        appendStoredParam(url, 'student', 'student_name');
        appendStoredParam(url, 'student_identifier', 'student_identifier');
        appendStoredParam(url, 'teacher_first', 'teacher_first_name');
        appendStoredParam(url, 'teacher_last', 'teacher_last_name');
        appendStoredParam(url, 'teacher_name', 'teacher_name');
        link.setAttribute('href', url.pathname + url.search + url.hash);
      } catch (error) {
        return;
      }
    });
  }

  function appendStoredParam(url, paramName, storageName) {
    var value = readSession(storageName);
    if (value) url.searchParams.set(paramName, value);
  }

  function updateCartAttributes(data) {
    if (!window.fetch) return Promise.resolve();

    return fetch(getRoutesRoot() + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ attributes: data.cartAttributes }),
      keepalive: true
    }).catch(function () {
      return null;
    });
  }

  function isCartAddForm(form) {
    return /\/cart\/add/.test(form.getAttribute('action') || '');
  }

  function isCartOrCheckoutForm(form) {
    var action = form.getAttribute('action') || '';
    return /\/cart/.test(action) || /\/checkout/.test(action);
  }

  function getRoutesRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
  }

  function readSession(key) {
    try {
      return window.sessionStorage.getItem(storageKey(key)) || '';
    } catch (error) {
      return '';
    }
  }

  function writeSession(key, value) {
    try {
      if (value) {
        window.sessionStorage.setItem(storageKey(key), value);
      } else {
        clearSession(key);
      }
    } catch (error) {
      return;
    }
  }

  function clearSession(key) {
    try {
      window.sessionStorage.removeItem(storageKey(key));
    } catch (error) {
      return;
    }
  }

  function storageKey(key) {
    return 'compass_common_bearing_' + key;
  }

  function sanitizeCampaign(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9-_]/g, '')
      .trim();
  }

  function sanitizeToken(value) {
    return String(value || '')
      .replace(/[^A-Za-z0-9-_]/g, '')
      .trim();
  }

  function titleFromSlug(value) {
    return String(value || '')
      .replace(/[^A-Za-z0-9-_ ]/g, '')
      .trim()
      .split(/[-_ ]+/)
      .filter(Boolean)
      .map(function (part) {
        return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
      })
      .join(' ');
  }
})();
